import { useMemo } from 'react';
import { TmdxAvatar } from '@ds';
import { useRouteContext } from '@lp/core/contexts/RouteContext';
import { CaseResourceType } from '@/api/apis/case';
import { CrewLogisticsResourceType, TmdxJetAviaLeg } from '@/api/apis/route';

type TmdxLegInfoProps = {
  leg: TmdxJetAviaLeg;
};

export const TmdxLegInfo = ({ leg }: TmdxLegInfoProps) => {
  const { resourceById } = useRouteContext();
  const aircraftRegistration = useMemo(() => {
    const currentAircraftResource = leg.resources.find((r) => r.resourceType === CaseResourceType.Aircraft);
    const aircraftData = currentAircraftResource
      ? resourceById[CaseResourceType.Aircraft].get(currentAircraftResource.resourceId)
      : undefined;

    return aircraftData?.data?.registration || null;
  }, [leg.resources, resourceById]);

  const crewList = useMemo(() => {
    const crewResources = leg.resources.filter((r) => r.resourceType === CaseResourceType.Crew);

    return crewResources
      .map((r) => resourceById[CaseResourceType.Crew].get(r.resourceId))
      .filter((c): c is CrewLogisticsResourceType => Boolean(c));
  }, [leg.resources, resourceById]);

  if (!aircraftRegistration) {
    return null;
  }

  return (
    <div className="flex gap-1 items-center">
      <span className="text-s-sb text-base-10">{aircraftRegistration}</span>
      {crewList.map((item) => (
        <TmdxAvatar key={item.resourceId} type="user" size="sm" radius="full" />
      ))}
    </div>
  );
};
